export default __webpack_public_path__ + "static/media/dogecoin-doge-logo.a9424efa.png";